import React, { useState } from 'react';
import { Col, Container, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';


import explinellipse from '../../assets/images/e-linellipse.png'
import expiphone from '../../assets/images/e-iphone.png'
import exphome from '../../assets/images/e-home.png';
import expappstore from '../../assets/images/e-appstore.png';
import expplaystore from '../../assets/images/e-playstore.png';
import expblank from '../../assets/images/e-blank.png';
import expsearch from '../../assets/icons/e-search.png';
import expbuyer from '../../assets/icons/e-buyer.png';
import expseller from '../../assets/icons/e-seller.png';
import expfilter from '../../assets/icons/e-filter.png';
import expproperty from '../../assets/icons/e-property.png';
import expchat from '../../assets/icons/e-chat.png';
import { Link } from 'react-router-dom';
export default function Experience() {
    const [activeTab, setActiveTab] = useState('buyer');

    const handleTabChange = (tab) => {
      setActiveTab(tab);
    };
  return (
    <div className="experience">
    <div className="to-see">
        <Row className="m-0">
            <Col lg={1} md={1} sm={1} xs={12}></Col>
            <Col lg={5} md={5} sm={5} xs={12} style={{ position: "relative" }}>
                <div className="experiencetalks">
                    <div>
                        <h2>See how Eign can help</h2>
                        <div className="subscribe-field">
                            <div>
                                <input type="text" placeholder="Email" />
                            </div>
                            <button>Subscribe</button>
                        </div>
                    </div>
                </div>
                <div className="backimg" style={{ display: "none" }}>
                    <img src={exphome} alt="exphome" />
                </div>
            </Col>
            <Col lg={6} md={6} sm={6} xs={12} className="p-0">
                <div className="e-home">
                    <img src={exphome} alt="exphome" />
                </div>
            </Col>
        </Row>
    </div>
    <div className="bluebanner">
        <Container>
            <div className="btnclass">
                {/* <button className="buyerbtn">Buyer</button>
                <button className="sellerbtn">Seller</button> */}
                <button
          className={`buyerbtn ${activeTab === 'buyer' ? 'active' : ''}`}
          onClick={() => handleTabChange('buyer')}
        >
          Buyer
        </button>
        <button
          className={`sellerbtn ${activeTab === 'seller' ? 'active' : ''}`}
          onClick={() => handleTabChange('seller')}
        >
          Seller
        </button>
            </div>
            <Row className="m-0">
          {activeTab === 'buyer' && (
            <>
                 <Col lg={4} md={12} sm={12} xs={12} className="part1">
                    <Row className="m-0 search">
                        <Col lg={9} md={9} sm={8} xs={8}>
                            <p className="title">Search and Selection</p>
                            <p className="description">Use the automated system to search for properties based on your preferences and select potential options.</p>
                        </Col>
                        <Col lg={3} md={3} sm={4} xs={4}>
                            <div className="expproperty">
                                <img src={expsearch} alt="expsearch" />
                            </div>
                        </Col>
                    </Row>
                    <Row className="ellipseline">
                    {/* <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Search Property</Tooltip>}
                        >
                        <Link to='/search'> */}
                        <img src={explinellipse} alt="explinellipse" />
                        {/* </Link>
                        </OverlayTrigger>                  */}
                    </Row>
                    <Row className="m-0 search">
                        <Col lg={9} md={9} sm={8} xs={8}>
                            <p className="title">Virtual Viewing and Research</p>
                            <p className="description">Explore shortlisted properties through virtual tours and gather additional information using the system.</p>
                        </Col>
                        <Col lg={3} md={3} sm={4} xs={4}>
                            <img src={expbuyer} alt="expbuyer" />
                        </Col>
                    </Row>
                    <Row className="m-0 search">
                        <Col lg={9} md={9} sm={8} xs={8}>
                            <p className="title">Financing and Pre-Approval</p>
                            <p className="description">Connect with the system's integrated financial services to explore financing options and obtain pre-approval.</p>
                        </Col>
                        <Col lg={3} md={3} sm={4} xs={4}>
                            <img src={expseller} alt="expseller" />
                        </Col>
                    </Row>
                </Col>
                <Col lg={4} md={12} sm={12} xs={12} className="part2">
                    <img src={expiphone} alt="expiphone" />
                </Col>
                <Col lg={4} md={12} sm={12} xs={12} className="part3">
                    <Row className="m-0  search">
                        <Col lg={3} md={3} sm={4} xs={4}>
                            <img src={expfilter} alt="expfilter" />
                        </Col>
                        <Col lg={9} md={9} sm={8} xs={8}>
                            <p className="title">Digital Offer Submission and Negotiation</p>
                            <p className="description">Submit offers electronically through the system and negotiate with sellers using secure communication channels.</p>
                        </Col>
                    </Row>
                    <Row className="m-0 search">
                        <Col lg={3} md={3} sm={4} xs={4}>
                            <div className="expproperty">
                                <img src={expproperty} alt="expproperty" />
                            </div>
                        </Col>
                        <Col lg={9} md={9} sm={8} xs={8}>
                            <p className="title">Due Diligence and Documentation</p>
                            <p className="description">Complete necessary inspections, reviews, and documentation with the assistance of the system.</p>
                        </Col>
                    </Row>
                    <Row className="m-0 search">
                        <Col lg={3} md={3} sm={4} xs={4}>
                            <div className="expproperty">
                                <img src={expchat} alt="expchat" />
                            </div>
                        </Col>
                        <Col lg={9} md={9} sm={8} xs={8}>
                            <p className="title">Closing and Handover</p>
                            <p className="description">Coordinate the closing process and transfer of ownership using the system's secure platform.</p>
                        </Col>
                    </Row>
                </Col>
            </>
          )}
          {activeTab === 'seller' && (
            <>
                  <Col lg={4} md={12} sm={12} xs={12} className="part1">
                    <Row className="m-0 search">
                        <Col lg={9} md={9} sm={8} xs={8}>
                            <p className="title">Listing Creation</p>
                            <p className="description"> Create a detailed listing for your property, including its features, price, and photos.</p>
                        </Col>
                        <Col lg={3} md={3} sm={4} xs={4}>
                            <div className="expproperty">
                                <img src={expsearch} alt="expsearch" />
                            </div>
                        </Col>
                    </Row>
                    <Row className="ellipseline">
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Click and Add Property</Tooltip>}
                        >
                        <Link to='/submit-property'>
                        <img src={explinellipse} alt="explinellipse" />
                        </Link>
                        </OverlayTrigger>
                    </Row>
                    <Row className="m-0 search">
                        <Col lg={9} md={9} sm={8} xs={8}>
                            <p className="title">Marketing and Promotion</p>
                            <p className="description">Utilize the platform's tools to market and promote your listing to a wide audience.</p>
                        </Col>
                        <Col lg={3} md={3} sm={4} xs={4}>
                            <img src={expbuyer} alt="expbuyer" />
                        </Col>
                    </Row>
                    <Row className="m-0 search">
                        <Col lg={9} md={9} sm={8} xs={8}>
                            <p className="title">Inquiries and Communication</p>
                            <p className="description">Manage inquiries and communicate with potential buyers through the platform's messaging system.</p>
                        </Col>
                        <Col lg={3} md={3} sm={4} xs={4}>
                            <img src={expseller} alt="expseller" />
                        </Col>
                    </Row>
                </Col>
                <Col lg={4} md={12} sm={12} xs={12} className="part2">
                    <img src={expiphone} alt="expiphone" />
                </Col>
                <Col lg={4} md={12} sm={12} xs={12} className="part3">
                    <Row className="m-0  search">
                        <Col lg={3} md={3} sm={4} xs={4}>
                            <img src={expfilter} alt="expfilter" />
                        </Col>
                        <Col lg={9} md={9} sm={8} xs={8}>
                            <p className="title">Virtual Tours and Showings</p>
                            <p className="description">Provide virtual tours of your property to interested buyers through the platform's virtual tour capabilities.</p>
                        </Col>
                    </Row>
                    <Row className="m-0 search">
                        <Col lg={3} md={3} sm={4} xs={4}>
                            <div className="expproperty">
                                <img src={expproperty} alt="expproperty" />
                            </div>
                        </Col>
                        <Col lg={9} md={9} sm={8} xs={8}>
                            <p className="title">Offer Management and Negotiation</p>
                            <p className="description">Receive and negotiate offers from potential buyers using the platform's offer management tools.</p>
                        </Col>
                    </Row>
                    <Row className="m-0 search">
                        <Col lg={3} md={3} sm={4} xs={4}>
                            <div className="expproperty">
                                <img src={expchat} alt="expchat" />
                            </div>
                        </Col>
                        <Col lg={9} md={9} sm={8} xs={8}>
                            <p className="title">Closing and Transaction Completion</p>
                            <p className="description">transfer ownership using the platform's secure channels for document sharing and e-signatures.</p>
                        </Col>
                    </Row>
                </Col>
            </>
          )}
       
      </Row>
            {/* <Row className="m-0">
                <Col lg={4} md={12} sm={12} xs={12} className="part1">
                    <Row className="m-0 search">
                        <Col lg={9} md={9} sm={8} xs={8}>
                            <p className="title">Easy Search</p>
                            <p className="description">Don’t need a account, you can explore whole app But if you want to add home, buy, sell.</p>
                        </Col>
                        <Col lg={3} md={3} sm={4} xs={4}>
                            <div className="expproperty">
                                <img src={expsearch} alt="expsearch" />
                            </div>
                        </Col>
                    </Row>
                    <Row className="ellipseline">
                        <img src={explinellipse} alt="explinellipse" />
                    </Row>
                    <Row className="m-0 search">
                        <Col lg={9} md={9} sm={8} xs={8}>
                            <p className="title">For Buyer</p>
                            <p className="description">Don’t need a account, you can explore whole app But if you want to add home, buy, sell.</p>
                        </Col>
                        <Col lg={3} md={3} sm={4} xs={4}>
                            <img src={expbuyer} alt="expbuyer" />
                        </Col>
                    </Row>
                    <Row className="m-0 search">
                        <Col lg={9} md={9} sm={8} xs={8}>
                            <p className="title">For Seller</p>
                            <p className="description">Don’t need a account, you can explore whole app But if you want to add home, buy, sell.</p>
                        </Col>
                        <Col lg={3} md={3} sm={4} xs={4}>
                            <img src={expseller} alt="expseller" />
                        </Col>
                    </Row>
                </Col>
                <Col lg={4} md={12} sm={12} xs={12} className="part2">
                    <img src={expiphone} alt="expiphone" />
                </Col>
                <Col lg={4} md={12} sm={12} xs={12} className="part3">
                    <Row className="m-0  search">
                        <Col lg={3} md={3} sm={4} xs={4}>
                            <img src={expfilter} alt="expfilter" />
                        </Col>
                        <Col lg={9} md={9} sm={8} xs={8}>
                            <p className="title">Advance Filter</p>
                            <p className="description">Don’t need a account, you can explore whole app But if you want to add home, buy, sell.</p>
                        </Col>
                    </Row>
                    <Row className="m-0 search">
                        <Col lg={3} md={3} sm={4} xs={4}>
                            <div className="expproperty">
                                <img src={expproperty} alt="expproperty" />
                            </div>
                        </Col>
                        <Col lg={9} md={9} sm={8} xs={8}>
                            <p className="title">Submit Proerty</p>
                            <p className="description">Don’t need a account, you can explore whole app But if you want to add home, buy, sell.</p>
                        </Col>
                    </Row>
                    <Row className="m-0 search">
                        <Col lg={3} md={3} sm={4} xs={4}>
                            <div className="expproperty">
                                <img src={expchat} alt="expchat" />
                            </div>
                        </Col>
                        <Col lg={9} md={9} sm={8} xs={8}>
                            <p className="title">Chat with Buyer</p>
                            <p className="description">Don’t need a account, you can explore whole app But if you want to add home, buy, sell.</p>
                        </Col>
                    </Row>
                </Col>
            </Row> */}
        </Container>
    </div>
    <div className="downloadapp">
        <Container>
            <Row>
                <Col lg={6} md={6} sm={6} xs={12} className="downloadoption" style={{ position: "relative" }}>
                    <div >
                        <p>Download the app with everything for free.</p>
                        <img src={expappstore} alt="expappstore" className="expappstore" />
                        <img src={expplaystore} alt="expplaystore" className="expplaystore" />
                    </div>
                </Col>
                <Col lg={6} md={6} sm={6} xs={12}>
                    <img src={expblank} alt="expblank" className="expblank" />
                </Col>
            </Row>
        </Container>
    </div>

</div>
  )
}
